import {
    LayoutActivityType,
    NotificationSourceModule,
    SmartlyActionItems,
} from '@Techedge/digitalportal-shared'
import { NewsForm, SurveyTaskForm, TaskForm, VisitForm } from './new-activity-form'

interface BaseActivity {
    sectionMap: Record<string, ActivityStep>
}

interface BaseTask {
    isDone?: boolean
    isEdit?: boolean
}

export interface Survey extends BaseTask {}

export interface Answer {
    value: string
    disabled: boolean
}
export interface Question extends BaseTask {
    answerList: Answer[]
}

export interface Task extends BaseTask {
    questionList: Question[]
    startDate?: number
    endDate?: number
}

export interface ActivityStep {
    isDone?: boolean
    isDirty?: boolean
    isDisabled?: boolean
    label: string
    key?: string
}
export interface NewsActivity extends BaseActivity {
    typeList: NotificationSourceModule[]
    form: NewsForm
}
export interface TaskActivity extends BaseActivity {
    typeList: string[]
    form: TaskForm
}

export interface SurveyTaskActivity extends BaseActivity {
    form: SurveyTaskForm
}

export interface VisitSurvey {
    _id?: string
    surveyName: string
    surveyId: string
    surveyUrl: string
    duration: string
}
export interface VisitActivity extends BaseActivity {
    form: VisitForm
    selectedSurveys: VisitSurvey[]
    surveyList: VisitSurvey[]
    surveyListLoading: boolean
}

export interface VisitOverlapTimeData {
    eventName: string
    eventStartData: number
    slots: number[]
}
export interface ActivityType {
    key: LayoutActivityType
    icon: string
    active?: boolean
    subTypes: any[]
}

export class NewActivityCreationCta {
    label: string
    defaultLabel?: string
    action: string
    variant?: string
    icon?: string
    permission?: any
    subject: SmartlyActionItems
    model?: any
    disabled

    constructor(data?: any) {
        if (data) {
            Object.assign(this, data)
            this.permission = data.permission
        }
    }

    public show = () => {
        // console.log(
        //     `CAN  ${this.action}-----------------`,
        //     "MODEL",
        //     this.model,
        //     `PERMITTED: ${this.permission(this.subject, this.model)}`
        // )

        return this.permission(this.subject, this.model)
    }
}
export class NewActivityCreationCtaConfig {
    left: NewActivityCreationCta[]
    right: NewActivityCreationCta[]

    constructor(data?: any) {
        if (data) {
            Object.assign(this, data)
        }
    }

    setDisableConditions(conditions: { action: any; disableCondition: boolean }[]) {
        this.left = this.left.map((item: NewActivityCreationCta) => {
            let condition = conditions.find((_condition: any) => item.action === _condition.action)
            if (condition && item.action === condition.action) {
                item.disabled = condition.disableCondition
            }
            return item
        })
        this.right = this.right.map((item: NewActivityCreationCta) => {
            let condition = conditions.find((_condition: any) => item.action === _condition.action)
            if (condition && item.action === condition.action) {
                item.disabled = condition.disableCondition
            }
            return item
        })

        return this
    }
}
